<template>
  <power-wrapper :CurrRole="CurrRole">
    <div class="distributorList">
      <div class="topLeft">
        <h3>全链路数据<span class="time">*当前页面数据是离线数据，刨除了取消进量数据。</span></h3>
        <div class="refresh">&nbsp;</div>
      </div>
      <div class="terms">
        <el-form :inline="true" :model="listQuery" label-position="left" ref="searchForm">
          <el-form-item label="选择学期：">
            <el-select v-model="term_ids" filterable placeholder="请选择学期" multiple @change="handleTermsChange" @remove-tag="handleTermsRemove" no-data-text="还没有学期数据">
              <el-option v-for="item in terms" :key="item.id" :label="item.termTagName" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="statistics" >
        <li class="card">
          <div class="date">公益课人数</div>
          <div class="sum">{{ sum.get_account_num_str || '0' }}</div>
        </li>
        <li class="card">
          <div class="date">体验课人数</div>
          <div class="sum">{{ sum.l1_user_num || '0' }}</div>
        </li>
        <li class="card">
          <div class="date">续报人数</div>
          <div class="sum">{{ sum.renewal_num_str || '0' }}</div>
        </li>
        <li class="card">
          <div class="date">GMV（元）</div>
          <div class="sum">{{ sum.annual_real_pay_str || '0' }}</div>
        </li>
      </div>
      <el-button class="download_btn" type="primary" icon="el-icon-download" @click="downloadB2CTable">下载表格</el-button>
      <el-table v-loading="listLoading" :data="list" :empty-text="emptyText" border fit highlight-current-row
        style="width: 100%" :header-cell-style="tableHeader">
        <el-table-column label="学期" align="center">
          <template slot-scope="{row}">
            <span>{{ row.b2c_term_tag_name_concat || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="学校" align="center">
          <template slot-scope="{row}">
            <span>{{ row.b2c_school_name || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="公益课人数" align="center">
          <template slot-scope="{row}">
            <span>{{ row.get_account_num_str || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="进群率" align="center">
          <template slot-scope="{row}">
            <span>{{ row.enter_wechat_rate_str || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="加微率" align="center">
          <template slot-scope="{row}">
            <span>{{ row.add_wx_rate_str || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="激活率" align="center">
          <template slot-scope="{row}">
            <span>{{ row.active_rate_str || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="体验课流转率" align="center">
          <template slot-scope="{row}">
            <span>{{ row.l1_flow_rate_str || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="续报人数" align="center">
          <template slot-scope="{row}">
            <span>{{ row.renewal_num_str || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="GMV（元）" align="center">
          <template slot-scope="{row}">
            <span>{{ row.annual_real_pay_str || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="大盘转化率" align="center">
          <template slot-scope="{row}">
            <span>{{ row.convert_rate_str || '--' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="listQuery.index" :limit.sync="listQuery.pageSize"
        @pagination="getList" />
    </div>
  </power-wrapper>
</template>
<script>
import PowerWrapper from "@/components/PowerWrapper";
import Pagination from "@/components/Pagination/index";
// import DownExcel2 from "@/components/DownExcel/download2";
import { getTeamCode, isCampus } from '@/utils/auth'
import { delUndefined } from '@/utils/utils';
import {
  apiGetB2CTermSum, apiGetB2CTermList, apiGetB2CTerms, apiDownloadB2CSfullLinkTable,
  apiGetCampusTermSum, apiGetCampusTermList, apiDownloadCampusSfullLinkTable
} from "@/services/b2cStatement";

export default {
  name: 'fullLink',
  components: {
    Pagination,
    PowerWrapper
  },
  props: {
  },
  computed: {
    tableHeader() {
      return { 'background-color': '#f5f5f5' }
    },
  },
  data () {
    return {
      list: [],
      terms: [],
      term_ids: [],
      termDefault: null,
      statisticsArr: [],
      listLoading: false,
      apiPath: '/star/mobile/btoc/term/formOffline/download',
      CurrRole: "B2C_PWcourse_Data",
      emptyText: '暂无数据',
      total: 0,
      sum: {},
      listQuery: {
        team_id: getTeamCode(),
        orderColumn: "b2c_term_tag_name",
        orderType: "desc",
        b2c_term_tag_names: [],
        index: 1,
        pageSize: 10,
      },
    }
  },
  created() {
    this.getTerms();
  },
  methods: {
    setTermDefault() {
      const { termDefault, terms, term_ids } = this;
      const _termDefault = termDefault || terms[0]?.id;
      if (this.listQuery.b2c_term_tag_names.length === 0 && _termDefault) {
        const term = terms.find(item => item.id === _termDefault);
        this.listQuery.b2c_term_tag_names = [term.termTagName];
        this.term_ids = [term.id];
      } else {
        this.listQuery.b2c_term_tag_names = term_ids.map(id => terms.find(item => item.id === id).termTagName);
      }
    },
    handleTermsRemove() {
      this.setTermDefault();
    },
    handleTermsChange(v) {
      const first = v[0];
      if (first) this.termDefault = first;
      this.listQuery.b2c_term_tag_names = v;
      this.setTermDefault();
    },
    handleQuery() {
      this.getSum();
      this.getList('search');
    },
    getTerms() {
      apiGetB2CTerms().then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.terms = res.data.data;
          this.setTermDefault();
          this.getSum();
          this.getList();
        } else {
          this.terms = [];
        }
      });
    },
    async getSum() {
      const {
        listQuery: {
          team_id,
          b2c_term_tag_names
        }
      } = this;
      const params = {
        team_id,
        b2c_term_tag_names
      }
      try {
        const res = await (isCampus() ? apiGetCampusTermSum(params) : apiGetB2CTermSum(params));
        const { data = [], errCode } = res.data;
        if (errCode === 0) {
          this.sum = data[0] || {};
        } else {
          this.sum = [];
        }
      } catch (error) {
        console.log(error);
        this.sum = [];
      }
    },
    async getList(btnName) {
      this.listLoading = true;
      const { listQuery } = this
      const params = {
        ...listQuery,
      }
      if (btnName === 'search') {
        params.index = 1;
      }
      try {
        const res = await (isCampus() ? apiGetCampusTermList(delUndefined(params)) : apiGetB2CTermList(delUndefined(params)));
        const { data, errCode, total } = res.data;
        if (errCode === 0) {
          this.listLoading = false;
          this.list = data;
          this.total = total;
        } else {
          this.listLoading = false;
          this.list = [];
          this.total = 0;
        }
      } catch (error) {
        console.log(error);
        this.listLoading = false;
        this.list = [];
        this.total = 0;
      }
    },
    downloadB2CTable() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.6)",
      });
      const params = {
        ...this.listQuery,
        pageSize: this.total,
      };
      (isCampus() ? apiDownloadCampusSfullLinkTable(params) : apiDownloadB2CSfullLinkTable(params))
        .then((res) => {
          setTimeout(() => {
            this.loading.close();
          }, 1000);
          const { data, errCode } = res.data;
          if (errCode === 0 && data) {
            const downloadElement = document.createElement("a");
            downloadElement.href = data;
            document.body.appendChild(downloadElement);
            downloadElement.click(); // 点击下载
            document.body.removeChild(downloadElement); // 下载完成移除元素
          } else {
            this.$message({ type: "error", message: res.data.errMsg });
          }
        })
        .catch((error) => {
          setTimeout(() => {
            this.loading.close();
          }, 1000);
          this.$message({ type: "error", message: error });
        });
    },
  }
}
</script>
<style lang="less" scoped>
@import '../../styles/common.less';
.download_btn {
  float: right;
  margin: 3px auto 30px 20px;
}
</style>
